import request from '@/utils/request'
export function login(data) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/Home/login',
    method: 'post',
    data: {
      LoginName: data.userName,
      LoginPass: data.userPass,
    }
  })
}

//微信和qq授权后登录系统
export function Authlogin(data) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/Home/Authlogin',
    method: 'post',
    params: data
  })
}

//APP扫码登陆
export function AppScanCodeLogin(data) {
  return request({
      baseURL: process.env.VUE_APP_System_Api,
      url: '/Home/AppScanCodeLogin',
      method: 'post',
      params: data
  })
}

export function register(data) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    headers: {
      'Content-Type': 'application/json-patch+json'
    },
    url: '/Home/register',
    method: 'post',
    data

  })
}
/**
 * 
 * @param {id} 用户ID 
 */
export function getUserDetail(data) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/user/detail',
    method: 'get',
    params: data
  })
}

export function GetEnterprisetypeByDeptID(data) {
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/PersonalCenter/GetEnterprisetypeByDeptID',
    method: 'post',
    params: data
  })
}

//退出登录
export function Logout(data) {
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/Register/Logout',
    method: 'post',
    params: data
  })
}

//根据用户ID获取其企业信息
export function GetEnterprisesByID(data) {
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/Enterprises/GetEntityByID',
    method: 'post',
    params: data
  })
}

/**
 * 更新用户密码
 * @param {ID} 用户ID 
 * @param {OldPassword} 旧密码 
 * @param {NewPassword} 新密码 
 * @param {RepeatPassword} 用户ID 
 */
export function editPassword(data) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/user/editpassword',
    method: 'post',
    data

  })
}

/**
 * 更新个人信息
 * @param {ID} 用户ID 
 * @param {OldPassword} 旧密码 
 * @param {NewPassword} 新密码 
 * @param {RepeatPassword} 用户ID 
 */
export function editSelfInfo(data) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/user/editinfo',
    method: 'post',
    data

  })
}

/**
 * 更新头像
 * @param {ID} 用户ID 
 * @param {OldPassword} 旧密码 
 * @param {NewPassword} 新密码 
 * @param {RepeatPassword} 用户ID 
 */
export function editUserImage(data) {
  return request({
    headers: {
      'Content-Type': 'application/json-patch+json'
    },
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/user/editheadimage',
    method: 'post',
    data
  })
}
//获取用户菜单
export function getUserMenu(pid) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/Base/Common/GetAllSonModules',
    method: 'post',
    stringify: true,
    data: {
      pid: process.env.VUE_APP_MENU_ID
    }
    //data: qs.stringify({ pid: process.env.VUE_APP_MENU_ID })
  })
}
//根据token获取用户信息
export function getUserByToken() {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/Home/userinfo',
    method: 'get',
  })
}


//获取新token
export function getNToken(data) {
  return request({
      baseURL:  process.env.VUE_APP_System_Api,
      url: '/Home/gettoken',
      method: 'get',
      notShowMsg:true,
      hideLoading:true,
  })
}

//获取token剩余有效时间
export function getTokenTime(data) {
  return request({
      baseURL:  process.env.VUE_APP_System_Api,
      url: '/Home/gettokenexpired',
      method: 'get',
      notShowMsg:true,
      hideLoading:true,
  })
}

// export function getInfo(token) {
//     return request({
//         url: '/api/user/info',
//         method: 'get',
//         params: { token }
//     })
// }

// export function logout() {
//     return request({
//         url: '/api/user/logout',
//         method: 'post'
//     })
// }


// WEBPACK FOOTER //
// ./src/api/user.js